import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import Button from "../Reusable/Button";
import ComboboxInput from "../Reusable/ComboboxInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import TextField from "../Reusable/TextInput";
import { createBranchServiceValidationForm } from "../../utils/validationSchemas";
import usePostHook from "../../customHooks/usePostHook";

const CreateUserBranch = ({ setIsOpen }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createBranchServiceValidationForm),
  });
  const { mutateAsync: createBranch, isPostLoading: isBranchloading } =
    usePostHook({
      queryKey: ["branch"],
      navigateURL: "",
    });

  const handleCreateBranch = async (values: any, setError: any) => {
    const url = `${APIS.USER_BRANCH}`;

    let formData = {
      ...values,
    };
    try {
      const res = await createBranch({ url, formData, setError });
      if (res.status == 201) {
        setIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const isLoading = false;
  return (
    <form
      onSubmit={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit((data) => handleCreateBranch(data, setError))(e);
      }}
    >
      <div className={tw`grid md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Code"}
          register={register("code")}
          errors={errors?.code}
        />
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"Email"}
          register={register("primary_email")}
          errors={errors?.primary_email}
        />
        <PhoneNumberField
          control={control}
          label={"Primary Phone"}
          name={"primary_contact"}
          errors={errors?.primary_contact}
        />
        <TextField
          label={"VAT/PAN"}
          register={register("vat_pan")}
          errors={errors?.vat_pan}
        />
      </div>
      <div className={tw`w-full px-4 `}>
        <div className={tw`w-24 ml-auto`}>
          <Button label="Create" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateUserBranch;
